// extracted by mini-css-extract-plugin
export default {"activeTab":"styles_activeTab__r4w3K"};